import { Controller } from 'stimulus';

// Loads the phone Jobs list a page at a time as you scroll
// (app/views/mobile/work/_page). The marker at the end of each page carries
// the next page's URL; when it comes within a screen of view, the next page
// is fetched and put in its place, bringing its own marker until the view
// runs out. A failed load turns the marker into a Try again button.
export default class extends Controller {
  static targets = ['marker'];

  connect() {
    this.loading = false;
    this.observer = new IntersectionObserver((items) => {
      if (items.some((item) => item.isIntersecting)) this.load();
    }, { rootMargin: '600px 0px' });
    this.watch();
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }

  watch() {
    this.observer.disconnect();
    if (this.hasMarkerTarget) this.observer.observe(this.markerTarget);
  }

  load() {
    if (this.loading || !this.hasMarkerTarget) return;

    const marker = this.markerTarget;
    this.loading = true;
    marker.textContent = 'Loading more jobs…';
    fetch(marker.dataset.nextUrl, { credentials: 'same-origin', headers: { Accept: 'text/html' }, redirect: 'manual' })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      .then((html) => {
        marker.insertAdjacentHTML('beforebegin', html);
        marker.remove();
        this.loading = false;
        this.watch();
      })
      .catch(() => {
        this.loading = false;
        marker.innerHTML = '<button type="button" class="mb-more-retry">Couldn’t load more jobs. Try again</button>';
        marker.querySelector('button').addEventListener('click', () => this.load(), { once: true });
      });
  }
}
